var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscordS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.47095 2.6483C8.82363 2.34544 8.13149 2.12533 7.40787 2C7.31901 2.16067 7.21518 2.37678 7.1436 2.54869C6.37437 2.43301 5.61223 2.43301 4.85715 2.54869C4.78558 2.37678 4.6794 2.16067 4.58973 2C3.86534 2.12533 3.1724 2.34625 2.52508 2.64991C1.21943 4.62291 0.865495 6.54691 1.04247 8.44358C1.90844 9.09027 2.74767 9.48311 3.57274 9.74018C3.77645 9.45981 3.95814 9.16177 4.11466 8.84767C3.81656 8.7344 3.53105 8.59462 3.26128 8.43234C3.33285 8.37932 3.40286 8.32388 3.47049 8.26685C5.11591 9.03645 6.90371 9.03645 8.52947 8.26685C8.5979 8.32388 8.6679 8.37932 8.73868 8.43234C8.46812 8.59541 8.18183 8.73519 7.88373 8.84848C8.04025 9.16177 8.22115 9.46062 8.42565 9.74097C9.25151 9.48391 10.0915 9.09108 10.9575 8.44358C11.1651 6.24485 10.6028 4.33853 9.47095 2.6483ZM4.33882 7.27714C3.84488 7.27714 3.43981 6.81602 3.43981 6.25449C3.43981 5.69296 3.83623 5.23104 4.33882 5.23104C4.84143 5.23104 5.24648 5.69215 5.23783 6.25449C5.23861 6.81602 4.84143 7.27714 4.33882 7.27714ZM7.66114 7.27714C7.1672 7.27714 6.76213 6.81602 6.76213 6.25449C6.76213 5.69296 7.15854 5.23104 7.66114 5.23104C8.16373 5.23104 8.5688 5.69215 8.56015 6.25449C8.56015 6.81602 8.16373 7.27714 7.66114 7.27714Z",
    fill: "#EEE0F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscordS);
export default __webpack_public_path__ + "static/media/discord-s.dcf32fb071a9976733bd435dee86373e.svg";
export { ForwardRef as ReactComponent };